import type { SVGProps } from "react";

/** Veganify leaf mark, recolored per theme via currentColor. */
export function Logo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      viewBox="0 0 500 450"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="ArtBoard1"
        transform="matrix(0.98659,0,0,0.986434,0.57142,-27.4677)"
      >
        <rect
          width="506.162"
          height="455.951"
          x="-.579"
          y="27.845"
          fill="none"
        />
        <g>
          <g>
            <path
              d="M13.511,18.965C13.157,19.439 13.083,19.947 13.398,20.5C13.398,20.589 39.771,73.173 46.545,86.721C47.541,88.714 48.64,89.234 48.653,89.237C49.603,89.48 50.047,89.385 50.703,87.419C53.248,79.789 61.123,59.378 65.711,50.394C67.91,51.195 70.012,51.496 72.012,51.496C76.813,51.496 80.91,49.394 84.012,45.296C88.41,39.398 87.91,31.898 87.512,25.796C87.313,22.296 87.113,18.898 88.113,17.597C88.313,17.297 88.414,16.898 88.414,16.597C88.414,16.097 88.215,15.496 87.715,15.199C86.914,14.597 85.817,14.8 85.317,15.597C84.317,16.898 81.117,17.699 77.617,18.496C71.719,19.894 64.418,21.695 60.015,27.597C55.117,34.199 56.015,41.995 62.414,48.898L62.515,49C59.715,54.199 57.215,59.5 54.816,64.898C43.827,41.723 31.883,21.473 31.214,18.898C31.067,18.333 30.316,18.097 29.714,18.097L15.198,18.101L15.097,18.101C15.097,18.101 14.594,18.062 14.21,18.266C13.826,18.47 13.561,18.916 13.511,18.965ZM63,29.801C66.602,24.903 73,23.403 78.602,22.102C80.602,21.602 82.5,21.204 84.102,20.602C84,22.301 84.102,24.204 84.301,26.301C84.7,32.102 85.102,38.602 81.403,43.5C77.301,49 71.801,48.801 67.704,47.602C70.602,42.301 73.805,37.204 77.305,32C77.805,31.199 77.606,30.101 76.805,29.601C76.005,29.101 74.907,29.301 74.407,30.101C70.805,35.402 67.606,40.703 64.606,46.101C61.501,42.5 58.102,36.398 63.001,29.8L63,29.801ZM53,69.5C53,69.602 53.102,69.602 53.102,69.699C51.5,73.801 49.902,77.899 48.5,82.097C37.162,58.918 28.592,41.385 18.301,21.699L29,21.699C30.677,26.614 42.406,46.91 53,69.5L53,69.5Z"
              fill="currentColor"
              fillRule="nonzero"
              transform="matrix(6.82085,0,0,6.82192,-3897.94,-371.953) matrix(0.548925,0,0,0.548925,580.695,62.3616)"
            />
          </g>
          <g>
            <path
              d="M30.668,9.18C24.027,9.18 17.383,11.734 12.305,16.828C2.149,27.012 2.149,43.484 12.305,53.668L14.36,55.735L48.895,90.36C49.188,90.652 49.586,90.82 50,90.82C50.414,90.82 50.813,90.652 51.106,90.36L85.629,55.734L87.695,53.668C97.851,43.484 97.851,27.012 87.695,16.828C77.539,6.644 61.105,6.656 50.949,16.84L50.004,17.797L49.047,16.84C43.965,11.746 37.309,9.184 30.668,9.18L30.668,9.18ZM69.32,12.293C75.156,12.293 80.992,14.543 85.48,19.039C94.453,28.035 94.453,42.465 85.48,51.461L83.414,53.52L50,87.036L16.574,53.52L14.507,51.465C5.534,42.469 5.534,28.039 14.507,19.043C18.992,14.543 24.823,12.305 30.667,12.309C36.507,12.309 42.339,14.547 46.827,19.043L48.894,21.109C49.187,21.402 49.585,21.566 49.999,21.566C50.413,21.566 50.812,21.402 51.105,21.109L53.159,19.043C57.648,14.543 63.483,12.297 69.319,12.297L69.32,12.293Z"
              fill="currentColor"
              transform="matrix(6.82085,0,0,6.82192,-3897.94,-371.953) matrix(0.815852,0,0,0.815852,567.689,51.276)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
